/**
 * 通知ダイアログ用のデータを保持するクラス
 */
export default class NotificationDialogData {
    /**
     * メッセージで使用するキー\
     * i18nで設定されているキーの形式
     */
    private _messageKey: string;

    /**
     * コンストラクタ
     * @param messageKey メッセージ用キー
     */
    constructor(
        messageKey: string,
    ) {
        this._messageKey = messageKey;
    }

    /**
     * getter メッセージ用のキー取得
     */
    public get messageKey(): string {
        return this._messageKey;
    }
}
